<template>
  <div class="honor-al">
    <div class="honor">
      <h3>
        <span>公司荣誉</span>／Company Honor
      </h3>
      <div class="honor-list">
        <ul>
          <li>
            <img src="https://img-oss.yunshanmeicai.com/cfile/f8e11aede36d905067ffcc245c78d35b.png" />
          </li>
          <li>
            <img src="https://img-oss.yunshanmeicai.com/cfile/42608b22c130609ff39e81876dd9908b.png" />
          </li>
          <li>
            <img
              src="https://img-oss.yunshanmeicai.com/site/card.png?x-oss-process=image/resize,w_250"
            />
          </li>
          <li>
            <img src="https://img-oss.yunshanmeicai.com/cfile/4eeb5620d9db85f084ffb2d64a343183.png" />
          </li>
          <li>
            <img src="https://img-oss.yunshanmeicai.com/cfile/efb3d67cb42876c22c0372dff95e55ab.png" />
          </li>
          <li>
            <img src="https://img-oss.yunshanmeicai.com/cfile/658057fbceea2666935ef18a3559299d.png" />
          </li>
          <li>
            <img src="https://img-oss.yunshanmeicai.com/cfile/686801f361b164e08c273495ccf27685.png" />
          </li>
          <li>
            <img src="https://img-oss.yunshanmeicai.com/cfile/0a7969e1844921d3df2d6c9b783f49da.png" />
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "honor",
  data() {
    return {};
  }
};
</script>

<style lang="scss" scoped>
.honor-al {
  padding: 50px 0;
  width: 100%;
  display: inline-block;
  background: #f8f8f8;
  .honor {
    width: 1000px;
    margin: 0 auto;
    h3 {
      margin: 0;
      padding: 0;
      font-size: 18px;
      text-align: center;
      span {
        font-size: 30px;
      }
    }
    ul {
      padding-top: 26px;
      width: 100%;
      display: inline-block;
      li {
        float: left;
        margin: 12px 0;
      }
    }
  }
}
</style>